import React, { useState, useEffect } from 'react';
import ContactService from '../services/ContactService';

function ContactAdmin() {
  const [storedContacts, setStoredContacts] = useState([]);

  useEffect(() => {
    loadStoredContacts();
  }, []);

  const loadStoredContacts = () => {
    const contacts = ContactService.getStoredContacts();
    setStoredContacts(contacts);
  };

  const clearStoredContacts = () => {
    if (window.confirm('Are you sure you want to clear all stored contact messages?')) {
      ContactService.clearStoredContacts();
      setStoredContacts([]);
    }
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  // Only show in development mode
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return (
    <div style={{ 
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      background: '#f8f9fa', 
      border: '1px solid #dee2e6', 
      borderRadius: '8px', 
      padding: '15px', 
      maxWidth: window.innerWidth <= 768 ? '90vw' : '400px',
      maxHeight: '500px',
      overflow: 'auto',
      zIndex: 1000,
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      fontSize: window.innerWidth <= 480 ? '12px' : '14px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <h6 style={{ margin: 0, color: '#495057' }}>Contact Messages ({storedContacts.length})</h6>
        <div>
          <button 
            onClick={loadStoredContacts}
            style={{ 
              marginRight: '5px', 
              padding: '2px 8px', 
              fontSize: '12px',
              border: '1px solid #007bff',
              background: '#007bff',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Refresh
          </button>
          <button 
            onClick={clearStoredContacts}
            style={{ 
              padding: '2px 8px', 
              fontSize: '12px',
              border: '1px solid #dc3545',
              background: '#dc3545',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Clear
          </button>
        </div>
      </div>
      
      {storedContacts.length === 0 ? (
        <p style={{ margin: 0, color: '#6c757d', fontSize: '14px' }}>No stored messages</p>
      ) : (
        <div>
          {storedContacts.map((contact, index) => (
            <div 
              key={contact.id || index} 
              style={{ 
                border: '1px solid #e9ecef', 
                borderRadius: '4px', 
                padding: '10px', 
                marginBottom: '10px',
                background: 'white'
              }}
            >
              <div style={{ fontSize: '12px', color: '#6c757d', marginBottom: '5px' }}>
                {formatDate(contact.timestamp)}
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '3px' }}>
                {contact.name} ({contact.email})
              </div>
              <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#495057', marginBottom: '3px' }}>
                {contact.subject}
              </div>
              <div style={{ fontSize: '12px', color: '#6c757d' }}>
                {contact.message}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContactAdmin;
